import React, { useState, useEffect } from "react";
import dayjs from "dayjs";
import { Badge } from "antd";

import {
    ChatItemContainer,
    AvatarContainer,
    ChatItemDetails,
    CategoryPatientContainer,
    Category,
    Patient,
    ChatLastEventTime,
    NoCountPlaceholder,
} from './Styles'

export const ChatList = ({ chatList, caseDetails, chatSelection }) => {
  const [chatListItems, setChatListItem] = useState([]);

  useEffect(() => {
    setChatListItem(chatList);
  }, [chatList]);

  const handleChatListClick = (chatDetails) => {
    chatSelection(chatDetails);
  };

  return (
    <div className='chatlist-item-wrapper'>
      {chatListItems.map((eachChat) => (
        <ChatItemContainer
          onClick={() => handleChatListClick(eachChat)}
        >
          <AvatarContainer url={eachChat.photo ? eachChat.photo : null}/>
          <ChatItemDetails>
            <CategoryPatientContainer>
              <Category>{eachChat.categoryName}</Category>
              <Patient>{eachChat.name}</Patient>
            </CategoryPatientContainer>
            <ChatLastEventTime>
              { eachChat.count > 0 
                ? <Badge count={eachChat.count}/>
                : <NoCountPlaceholder/>
              }
              {dayjs(eachChat.date).fromNow()}
            </ChatLastEventTime>
          </ChatItemDetails>
        </ChatItemContainer>
      ))}
    </div>
  );
};

export default ChatList;
